export default __webpack_public_path__ + "static/media/home_background.261694e2.jpg";